<template>
    <div class="quoteddetails">
        <div class="quoteddatedatils">
            <v-layout row >
                <v-flex xs11 offset-xs1>
            <span class="info-title">{{$t('Cover.ShowCover.QUOTE_DETAILS_DETAILS_SUB_TITLE')}}</span>
                <div class="divider">
                    <v-divider></v-divider>
                </div>
                <div class="quoteddatedetails">
                    <v-layout row  class="detailfieldinfo">
                        <v-flex xs6>
                            <v-label>{{$t('Cover.ShowCover.VALID_UNTIL_FIELD_NAME')}} :</v-label>
                        </v-flex>
                            <v-flex v-if="cover.details.isRemaining" xs6 class="latedetails">
                                {{cover.details.validUntil}}
                                <p class="lateinfo">
                                    {{$t('Cover.ShowCover.DAYS_REMAINING_DESC', { daysRemainingNumber: cover.details.daysRemaining })}}
                                </p>
                            </v-flex>
                            <v-flex v-else xs6>
                                {{cover.details.validUntil}}
                            </v-flex>
                    </v-layout>
                </div>
                </v-flex>
            </v-layout>
        </div>
        <div class="quotedprice" v-if="!!cover.details.totalCoverPrice">
            <div class="quotedpricecontent">
                <span class="quotepriceheader">
                    {{$t('Cover.ShowCover.COVER_PRICE_SUB_TITLE')}}
                </span>
                <div class="divider">
                <v-divider color="#ffffff"></v-divider>
                </div>
                <br>
                <v-layout row class="detailfieldinfo" v-if="!!cover.price.insurancePremiumAmount">
                    <v-flex xs6>
                        <v-label>{{$t('Cover.ShowCover.INSURANCE_PREMIUM_FIELD_NAME')}} : </v-label>
                    </v-flex>
                    <v-flex xs6>
                        {{cover.price.insurancePremiumAmount}} {{ cover.invoice.currency }}
                    </v-flex>
                </v-layout>
                <v-layout row class="detailfieldinfo" v-if="!!cover.price.insuranceTaxAmount">
                    <v-flex xs6>
                        <v-label>{{$t('Cover.ShowCover.INSURANCE_PREMIUM_TAX_FIELD_NAME')}} : </v-label>
                    </v-flex>
                    <v-flex xs6>
                        {{cover.price.insuranceTaxAmount}}
                    </v-flex>
                </v-layout>
                <v-layout row class="detailfieldinfo" v-if="!!cover.price.serviceFeeAmount">
                    <v-flex xs6>
                        <v-label>{{$t('Cover.ShowCover.SERVICE_FEES_FIELD_NAME')}} : </v-label>
                    </v-flex>
                    <v-flex xs6>
                            {{cover.price.serviceFeeAmount}}
                    </v-flex>
                </v-layout>
                <v-layout row class="detailfieldinfo" v-if="!!cover.price.serviceFeeVatAmount">
                    <v-flex xs6>
                        <v-label>{{$t('Cover.ShowCover.SERVICE_FEE_VAT_AMOUNT_FIELD_NAME')}} : </v-label>
                    </v-flex>
                    <v-flex xs6>
                            {{cover.price.serviceFeeVatAmount}}
                    </v-flex>
                </v-layout>
                <v-layout row class="detailfieldinfo" v-if="!!cover.price.collectionFeeAmount">
                    <v-flex xs6>
                        <v-label>{{$t('Cover.ShowCover.COLLECTION_FEE_AMOUNT_FIELD_NAME')}} : </v-label>
                    </v-flex>
                    <v-flex xs6>
                            {{cover.price.collectionFeeAmount}}
                    </v-flex>
                </v-layout>
                <v-layout row class="detailfieldinfo" v-if="!!cover.price.collectionFeeVatAmount">
                    <v-flex xs6>
                        <v-label>{{$t('Cover.ShowCover.COLLECTION_FEE_VAT_AMOUNT_FIELD_NAME')}} : </v-label>
                    </v-flex>
                    <v-flex xs6>
                            {{cover.price.collectionFeeVatAmount}}
                    </v-flex>
                </v-layout>
                <v-layout row class="detailfieldinfo" v-if="!!cover.price.technicalFeeAmount">
                    <v-flex xs6>
                        <v-label>{{$t('Cover.ShowCover.TECHNICAL_FEE_AMOUNT_FIELD_NAME')}} : </v-label>
                    </v-flex>
                    <v-flex xs6>
                            {{cover.price.technicalFeeAmount}}
                    </v-flex>
                </v-layout>
                <v-layout row class="detailfieldinfo" v-if="!!cover.price.technicalFeeVatAmount">
                    <v-flex xs6>
                        <v-label>{{$t('Cover.ShowCover.TECHNICAL_FEE_VAT_AMOUNT_FIELD_NAME')}} : </v-label>
                    </v-flex>
                    <v-flex xs6>
                            {{cover.price.technicalFeeVatAmount}}
                    </v-flex>
                </v-layout>
                <v-layout row class="detailfieldinfo">
                    <v-flex xs6>
                        <v-label>{{$t('Cover.ShowCover.TO_PAY_FIELD_NAME')}} : </v-label>
                    </v-flex>
                    <v-flex xs6>
                        <span class="price">{{cover.details.totalCoverPrice}}</span>
                    </v-flex>
                </v-layout>
            </div>

        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState('cover', ['cover'])
  }
}
</script>
<style scoped>
.quotedprice {
  border-radius: 5px;
  background-color: var(--primary-color);
  color: #ffffff;
  margin-top: 12px;
  margin-left: 19px;
}
.quotedpricecontent {
  padding: 18px 0px 18px 30px;
}
.quotedpricecontent .theme--light.v-label {
 color: #ffffff;
 font-size: 13px;
}
.quotedpricecontent .divider {
    width: 97%;
}
.quotepriceheader{
    font-size: 15px !important;
     font-style: normal;
}
.quotedpricecontent {
    font-size: 13px;
     font-style: normal;
}
.price{
   font-size: 16px;
   font-weight: bold;
}
.quoteddetails{
    margin-top: 33px;
}
.quoteddatedetails{
    margin-top: 20px;
}
</style>
